import { List } from 'immutable';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { FloatingModal } from '../../Modal';
import AchievementCircle from '../Circle';
import Button from '../../Button';
import RewardCircle from '../RewardCircle';
import styles from './achievementModal.scss';

const propTypes = {
  achievement: PropTypes.shape(),
  onRequestClose: PropTypes.func,
  offers: PropTypes.shape(),
  offersLoading: PropTypes.bool,
  onClaim: PropTypes.func.isRequired,
};

const AchievementModal = ({
  achievement,
  offers,
  offersLoading,
  onRequestClose,
  onClaim,
}) => (
  <FloatingModal
    isOpen={achievement !== null}
    onRequestClose={onRequestClose}
    buttonText="Close"
  >
    {achievement && (
      <div className={styles.modal}>
        <div className={styles.icon}>
          <AchievementCircle
            points={achievement.get('points')}
            image_id={achievement.get('image_id')}
            placeholder={!achievement.has('earned_at')}
            count={achievement.get('count')}
          />
        </div>
        <div className={styles.title}>
          {achievement.get('title')}
        </div>
        <div className={styles.earnedAt}>
          { achievement.get('earned_at')
            ? (
              <>
                <i className="far fa-check" />{' '}
                Earned <Moment fromNow element="span">{achievement.get('earned_at')}</Moment>
              </>
            ) : 'You haven\'t completed this achievement yet.'}
        </div>
        <div className={styles.description}>
          {achievement.get('description')}
        </div>

        <div className={styles.rewards}>
          {achievement.get('rewards', List()).map((item) => (
            <div
              className={styles.reward}
              key={item.get('name')}
            >
              <RewardCircle
                image_id={item.get('image_id')}
                size={36}
              />
              <div className={styles.rewardInfo}>
                <div className={styles.rewardName}>
                  {item.get('name')}
                </div>
                <div className={styles.rewardDescription}>
                  {item.get('description')}
                </div>
                {!offersLoading && item.get('offer_id') && offers.get(item.get('offer_id')) && (
                  <div className={styles.offer}>
                    <Button
                      outline
                      colors={{
                        text: '#fff',
                        border: '#fff',
                      }}
                      onClick={() => { onRequestClose(); onClaim(); }}
                    >
                      Claim this offer
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )).toArray()}
        </div>
      </div>
    )}
  </FloatingModal>
);

AchievementModal.propTypes = propTypes;

export default connect()(AchievementModal);
